// src/utils/stringUtils.ts

export const generateIndividualStoreName = (user: { first_name?: string; last_name?: string }): string => {
    const firstName = user?.first_name || '';
    const lastName = user?.last_name || '';
    const baseName = `${firstName} ${lastName}`.trim();
    
    if (!baseName) return '';
    
    // Add 's or just ' based on last character
    const suffix = baseName.endsWith('s') ? "'" : "'s";
    return `${baseName}${suffix} Store`;
};